<div class="renders">
  <div class="renders__content">
    <nb-card class="renders__content__current_render">
      <nb-card-body>
        <div
          class="renders__content__current_render__details"
          [nbSpinner]="!renders || !!(renders.length && !currentRender)"
        >
          <div
            *ngIf="renders && !renders.length"
            class="renders__content__current_render__details__no_renders"
          >
            <span>Viewer and photos are not available since this model doesn't have renders</span>
          </div>
          <div *ngIf="currentRender && analyticsData">
            <div class="renders__content__current_render__details__header">
              <span class="renders__content__current_render__details__header__label"
                >Current Render</span
              >
              <div class="renders__content__current_render__details__header__dates">
                <span
                  class="renders__content__current_render__details__header__value"
                  data-testId="current-render-value"
                >
                  {{ currentRender.createdAtDate.getTime() | date }}
                </span>
                <span
                  *ngIf="currentRender.captureDateDate"
                  class="renders__content__current_render__details__header__capture_date"
                  data-testId="current-render-capture-date"
                >
                  Captured: {{ currentRender.captureDateDate.getTime() | date }}
                </span>
              </div>
            </div>

            <nb-accordion class="renders__content__current_render__details__accordion">
              <nb-accordion-item expanded>
                <nb-accordion-item-header>
                  <nb-icon icon="bar-chart-outline"></nb-icon>
                  <span>Metrics</span>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <div class="renders__content__current_render__details__accordion_content">
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key">Gigapixels</span>
                      <span class="renders__content__current_render__details__value">{{
                        analyticsData.pixelsTotal || '-'
                      }}</span>
                    </div>
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key">Model Size</span>
                      <span class="renders__content__current_render__details__value">
                        <ng-container
                          *ngTemplateOutlet="
                            memorySizeTpl;
                            context: { value: analyticsData.modelSize }
                          "
                        ></ng-container>
                      </span>
                    </div>
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key"
                        >Image Size Total</span
                      >
                      <span class="renders__content__current_render__details__value">
                        <ng-container
                          *ngTemplateOutlet="
                            memorySizeTpl;
                            context: { value: analyticsData.imageSizeTotal }
                          "
                        ></ng-container>
                      </span>
                    </div>
                    <ng-container *ngIf="currentRender.orthoDSM || currentRender.pointCloud">
                      <div
                        *ngIf="currentRender.orthoDSM && currentRender.orthoDSM.isUploaded"
                        class="renders__content__current_render__details__row"
                      >
                        <span class="renders__content__current_render__details__key"
                          >Orthophoto/DSM</span
                        >
                        <span class="renders__content__current_render__details__value">
                          <a
                            [href]="currentRender.orthoDSM.downloadURL"
                            nbTooltip="Download TIFF files"
                            ><nb-icon icon="download-outline"></nb-icon>
                          </a>
                        </span>
                      </div>
                      <div
                        *ngIf="currentRender.pointCloud && currentRender.pointCloud.isUploaded"
                        class="renders__content__current_render__details__row"
                      >
                        <span class="renders__content__current_render__details__key"
                          >Point Cloud</span
                        >
                        <span class="renders__content__current_render__details__value">
                          <a
                            [href]="currentRender.pointCloud.downloadURL"
                            nbTooltip="Download LAS files"
                            ><nb-icon icon="download-outline"></nb-icon
                          ></a>
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </nb-accordion-item-body>
              </nb-accordion-item>

              <nb-accordion-item *ngIf="currentRender.inventory">
                <nb-accordion-item-header>
                  <nb-icon icon="grid-outline"></nb-icon>
                  <span>Inventory</span>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <div class="renders__content__current_render__details__accordion_content">
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key"
                        >Rad Centers</span
                      >
                      <span class="renders__content__current_render__details__value">{{
                        currentRender.inventory.radCenters || '-'
                      }}</span>
                    </div>
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key">Sectors</span>
                      <span class="renders__content__current_render__details__value">{{
                        currentRender.inventory.sectors || '-'
                      }}</span>
                    </div>
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key"
                        >Mount Groups</span
                      >
                      <span class="renders__content__current_render__details__value">{{
                        currentRender.inventory.mountGroups || '-'
                      }}</span>
                    </div>
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key">Antennas</span>
                      <span class="renders__content__current_render__details__value">{{
                        currentRender.inventory.antennas || '-'
                      }}</span>
                    </div>
                  </div>
                </nb-accordion-item-body>
              </nb-accordion-item>

              <nb-accordion-item>
                <nb-accordion-item-header>
                  <nb-icon icon="settings-outline"></nb-icon>
                  <span>Build Process</span>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <div class="renders__content__current_render__details__accordion_content">
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key"
                        >Build Process</span
                      >
                      <span class="renders__content__current_render__details__value">
                        <a
                          class="overview__actions--link"
                          [routerLink]="['/', companyId, 'processing', currentRender.id]"
                        >
                          <nb-icon icon="external-link-outline"></nb-icon>
                        </a>
                      </span>
                    </div>
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key"
                        >Aerotriangulation Log</span
                      >
                      <span class="renders__content__current_render__details__value">
                        <a (click)="showATLogs()" nbTooltip="Show AT log"
                          ><nb-icon icon="eye-outline"></nb-icon
                        ></a>
                      </span>
                    </div>
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key"
                        >Production Log</span
                      >
                      <span class="renders__content__current_render__details__value">
                        <a (click)="showProdLogs()" nbTooltip="Show Prod log"
                          ><nb-icon icon="eye-outline"></nb-icon
                        ></a>
                      </span>
                    </div>
                    <div class="renders__content__current_render__details__row">
                      <span class="renders__content__current_render__details__key">Upload Log</span>
                      <span class="renders__content__current_render__details__value">
                        <a (click)="showUploadLogs()" nbTooltip="Show Upload log"
                          ><nb-icon icon="eye-outline"></nb-icon
                        ></a>
                      </span>
                    </div>
                  </div>
                </nb-accordion-item-body>
              </nb-accordion-item>

              <nb-accordion-item>
                <nb-accordion-item-header>
                  <nb-icon icon="clock-outline"></nb-icon>
                  <span>Processing Duration</span>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <ng-container
                    *ngTemplateOutlet="
                      metricRowsTpl;
                      context: { rows: durationRows, cellTpl: durationTpl }
                    "
                  ></ng-container>
                </nb-accordion-item-body>
              </nb-accordion-item>

              <nb-accordion-item *ngxPermissionsOnly="permissions.CAN_SEE_PROCESSING_COST">
                <nb-accordion-item-header>
                  <nb-icon icon="credit-card-outline"></nb-icon>
                  <span>Processing Cost</span>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                  <ng-container
                    *ngTemplateOutlet="
                      metricRowsTpl;
                      context: { rows: costRows, cellTpl: currencyTpl }
                    "
                  ></ng-container>
                </nb-accordion-item-body>
              </nb-accordion-item>
            </nb-accordion>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer class="renders__links" *ngIf="currentRender">
        <ng-container *ngIf="currentRender">
          <a
            [routerLink]="[
              '/',
              companyId,
              'models',
              model.id,
              'renders',
              currentRender.id,
              'viewer'
            ]"
            nbButton
            status="primary"
          >
            <nb-icon icon="layers-outline"></nb-icon>
            Viewer
          </a>
          <a
            [routerLink]="[
              '/',
              companyId,
              'models',
              model.id,
              'renders',
              currentRender.id,
              'photos'
            ]"
            nbButton
            status="primary"
          >
            <nb-icon icon="image-outline"></nb-icon>
            Photos
          </a>
        </ng-container>
      </nb-card-footer>
    </nb-card>
    <nb-card class="renders__content__selection">
      <nb-card-body>
        <div class="renders__content__selection__filter_area">
          <app-filterable-list
            [entities]="renders"
            [selectedEntity]="currentRender"
            [dateField]="activeDateField"
            noEntitiesPlaceholder="No render to show"
            (changeEntity)="onRenderChange($event)"
          ></app-filterable-list>
          <div class="renders__content__selection__filter_area__date_mode">
            <nb-select
              size="tiny"
              data-testId="date-mode-select"
              [selected]="useCaptureDate"
              (selectedChange)="setDateMode($event)"
            >
              <nb-option [value]="false">Render date</nb-option>
              <nb-option [value]="true">Capture date</nb-option>
            </nb-select>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer class="renders__links" *ngIf="!model.isArchived">
        <button
          nbButton
          *ngxPermissionsOnly="permissions.CAN_UPLOAD_PHOTOS"
          (click)="onAddRenderClick()"
          status="primary"
          class="renders__links__add_render"
        >
          <nb-icon icon="plus-outline"></nb-icon>
          <span>Add Render</span>
        </button>
      </nb-card-footer>
    </nb-card>
  </div>
</div>

<app-logs-dialog
  *ngIf="isBuildProcessLogsDialogVisible"
  [logs]="buildProcessLogs$ | async"
  (closeLogsDialog)="closeBuildProcessLogsDialog()"
></app-logs-dialog>

<ng-template #metricRowsTpl let-rows="rows" let-cellTpl="cellTpl">
  <div class="renders__content__current_render__details__accordion_content">
    <div *ngFor="let row of rows" class="renders__content__current_render__details__row">
      <span class="renders__content__current_render__details__key">{{ row.label }}</span>
      <span class="renders__content__current_render__details__value">
        <ng-container *ngTemplateOutlet="cellTpl; context: { value: row.value }"></ng-container>
      </span>
    </div>
  </div>
</ng-template>

<ng-template #memorySizeTpl let-value="value">
  {{ (value | isNumeric) ? (value | memorySizeUnit) : '-' }}
</ng-template>

<ng-template #durationTpl let-value="value">
  {{ (value | isNumeric) ? (value | secondsToHoursAndMinutes) : '-' }}
</ng-template>

<ng-template #currencyTpl let-value="value">
  {{ (value | isNumeric) ? (value | currency) : '-' }}
</ng-template>
